"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ = require("../../../");

var _localforage = _interopRequireDefault(require("localforage"));

var api = _interopRequireWildcard(require("./api"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var getUser = function getUser() {
  var opts = {
    cors: false,
    contentType: "form",
    credentials: true
  };
  return api.get("".concat(process.env.REACT_APP_WEB_API, "/webapp/users/self"), {}, opts);
};

var loginUserWithPassword = function loginUserWithPassword(email, password) {
  var params = {
    email: email,
    password: password
  };
  var opts = {
    cors: false,
    contentType: "form",
    credentials: true
  };
  return api.post("".concat(process.env.REACT_APP_WEB_API, "/webapp/users/login"), params, opts);
};

var loginUserWithToken = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(userId, token) {
    var params, shouldAttemptLogin, opts, lastUsedLoginCodeWithTimestamp, splitResult, lastUsedTimestamp, tenMinutesAgo, lastUsedCode;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            params = {
              user_id: userId,
              code: token
            };
            _context.prev = 1;
            shouldAttemptLogin = true;
            opts = {
              cors: false,
              contentType: "form",
              credentials: true
            }; // Determine whether we should make the call by checking
            // whether the code is in storage or not

            _context.next = 6;
            return _localforage.default.getItem("last_used_login_code_with_timestamp");

          case 6:
            lastUsedLoginCodeWithTimestamp = _context.sent;

            if (lastUsedLoginCodeWithTimestamp) {
              splitResult = lastUsedLoginCodeWithTimestamp.split("---");
              lastUsedTimestamp = splitResult[1];
              tenMinutesAgo = Date.now() - 10 * 1000;
              lastUsedCode = splitResult[0]; // If the codes are different or the code was last
              // used more than 10 minutes ago, make another request

              if (token === lastUsedCode && lastUsedTimestamp > tenMinutesAgo) {
                shouldAttemptLogin = false;
                (0, _.trackEvent)({
                  category: "LoginDebug",
                  action: window.location.href
                });
              }
            }

            if (!shouldAttemptLogin) {
              _context.next = 13;
              break;
            }

            console.log("login code is valid");
            return _context.abrupt("return", new Promise(function (resolve, reject) {
              api.post("".concat(process.env.REACT_APP_WEB_API, "/webapp/users/login/by-code"), params, opts).then(function (res) {
                // Store the code and timestamp
                var rightNow = Date.now();

                _localforage.default.setItem("last_used_login_code_with_timestamp", "".concat(token, "---").concat(rightNow));

                resolve(res);
              }).catch(function (errRes) {
                reject(errRes);
              });
            }));

          case 13:
            console.log("login code is NOT valid"); // Else, do nothing, return rejected Promise

            return _context.abrupt("return", Promise.reject());

          case 15:
            _context.next = 20;
            break;

          case 17:
            _context.prev = 17;
            _context.t0 = _context["catch"](1);
            console.log("loging error", _context.t0);

          case 20:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 17]]);
  }));

  return function loginUserWithToken(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

var loginUser = function loginUser(_ref2) {
  var email = _ref2.email,
      password = _ref2.password,
      userId = _ref2.userId,
      token = _ref2.token,
      cb = _ref2.cb;

  if (email) {
    return loginUserWithPassword(email, password).then(function () {
      return getUser();
    }).then(function (user) {
      if (cb) {
        cb(user, null);
      }
    }).catch(function (err) {
      if (cb) {
        cb(null, err);
      }
    });
  } else if (userId) {
    return loginUserWithToken(userId, token).then(function () {
      return getUser();
    }).then(function (user) {
      if (cb) {
        cb(user, null);
      }
    }).catch(function (err) {
      if (cb) {
        cb(null, err);
      }
    });
  } else {
    if (cb) {
      cb(null, {
        message: "User Not Found"
      });
    }
  }
};

var _default = loginUser;
exports.default = _default;